/**
 * Browser push: reading the server's VAPID key answer (PUSH-SUB-1, BL-7eaa1b29).
 *
 * GET /api/notifications/vapid-key answers 200 { publicKey } when push is set up and 503 when it is not.
 * Kept free of the API client so the server tests can load it (server/test/push-settings.test.ts).
 */

/** The status the server answers when push has no VAPID keys yet. */
export const PUSH_NOT_CONFIGURED_STATUS = 503;

/** The public key in a vapid-key answer, or null when there is none. */
export function vapidPublicKeyFrom(data: unknown): string | null {
  const key = (data as { publicKey?: unknown } | null)?.publicKey;
  return typeof key === 'string' && key.trim() ? key.trim() : null;
}

/** True when a failed vapid-key request means "push is not set up" rather than a fault. */
export function isPushNotConfigured(error: unknown): boolean {
  const status = (error as { response?: { status?: unknown } } | null)?.response?.status;
  return status === PUSH_NOT_CONFIGURED_STATUS;
}

/** A base64url VAPID key as the bytes PushManager.subscribe takes for applicationServerKey. */
export function vapidKeyToBytes(key: string): ArrayBuffer {
  const padding = '='.repeat((4 - (key.length % 4)) % 4);
  const base64 = (key + padding).split('-').join('+').split('_').join('/');
  const raw = atob(base64);
  const buffer = new ArrayBuffer(raw.length);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return buffer;
}
